'use client';

import { SpeedInsights } from '@vercel/speed-insights/next';
import { useAnalyticsConsent } from '@/hooks/useAnalyticsConsent';

export default function ConsentGatedAnalytics() {
  const consented = useAnalyticsConsent();

  if (!consented) return null;
  return <SpeedInsights />;
}
